<template>
  <div class="signature-pad">
    <div
      class="signature-wrapper position-relative"
      :class="{ 'is-invalid': state === false }"
    >
      <img
        v-if="!edit"
        height="200px"
        width="100%"
        :src="value"
        :class="{ 'is-invalid': state === false }"
      />

      <VueSignaturePad
        v-show="edit"
        ref="signaturePad"
        :height="height"
        :options="{
          onBegin: () => {
            $refs.signaturePad.resizeCanvas();
          },
        }"
      ></VueSignaturePad>
      <div class="signature-buttons">
        <b-button
          v-show="!edit"
          class="signature-button"
          variant="primary"
          :disabled="disabled"
          @click="edit = true"
        >
          <i class="ifr if-pencil-short" />
        </b-button>
        <b-button
          v-show="edit"
          class="signature-button"
          variant="danger"
          @click="cancel"
        >
          <i class="ifr if-cancel" />
        </b-button>
        <b-button
          v-show="edit"
          class="signature-button"
          variant="primary"
          @click="confirm"
        >
          <i class="ifr if-check" />
        </b-button>
      </div>
    </div>
    <div v-if="state === false && invalidFeedback" class="invalid-feedback">
      {{ invalidFeedback }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "SignaturePad",
    props: {
      height: {
        type: String,
        default: "200px",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: String,
        default: null,
      },
      state: {
        type: Boolean,
        default: null,
      },
      invalidFeedback: {
        type: String,
        default: null,
      },
      noPreview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        edit: this.noPreview,
      };
    },
    methods: {
      confirm() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (!isEmpty) {
          this.edit = this.noPreview;
          this.$emit("input", data);
          this.$emit("signed", data);
          this.$refs.signaturePad.clearSignature();
        }
      },
      cancel() {
        this.$refs.signaturePad.clearSignature();
        this.edit = this.noPreview;
        this.$emit("sign-canceled");
      },
      clear() {
        this.$refs.signaturePad.clearSignature();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .signature-buttons {
    position: absolute;
    right: 0;
    bottom: 0;
  }
</style>
